export default {
  dismissButtonDisappearFor: 2,
  clickedBannerDisappearFor: 90
};
